// HIS情報マスタにない入力可能な定型文マスタ.
// TODO: 将来的には他のHis*Masterと合わせてマスタ化検討する事.
export class HisInformationFixedPhrasesMaster {
  static getFixedPhrases(key: string): string[] {
    // v1チームから回答されたHIS項目のみ対応.
    // マスタ化するまでの暫定対応なので実装は凝らない.
    switch (key) {
      case "DISEASE_FORMAL_NAME" :
      case "DISEASE_CHART_NAME" :
      case "ENTER_HOSP_MAIN_DISEASE" :
      case "LIS_REQUEST_DISEASE" :
        return [
          "不詳",
          "不明",
        ];
      default:
        return [];
    }
  }
}
